import React from 'react';
import { t } from '../../services/i18nService';
import viewReadyTracker from '../../services/ViewReadyTracker';
import styles from './permissionDenied.scss';

class PermissionDenied extends React.PureComponent {
    componentDidMount() {
        viewReadyTracker.getReporter()(true);
    }

    render() {
        return (
            <div className={styles.permissionDenied} role="main">
                <i className="fa fa-lock" />
                <span>{t('error.accessDenied')}</span>
            </div>
        );
    }
}

export default PermissionDenied;
